import { forwardRef, useTabsStyles } from '@chakra-ui/react-v2';

import { Box, type BoxProps } from '@frontend/legacy-components';

export type TabQuantityBadgeProps = BoxProps;

/**
 * A badge for showing a quantity associated with a `Tab` within the multipart `Tabs` component.
 */
export const TabQuantityBadge = forwardRef<TabQuantityBadgeProps, 'div'>(
  ({ className, children, ...restProps }, ref) => {
    const { number: numberStyles } = useTabsStyles();

    return (
      <Box
        ref={ref}
        __css={numberStyles}
        className={`tabs_quantitybadge ${className}`}
        {...restProps}
      >
        {children}
      </Box>
    );
  },
);
TabQuantityBadge.displayName = 'TabQuantityBadge';
